<script>
import ViewHeader from '@/components/ViewHeader.vue';
import StatCard from '@/components/StatCard.vue';
import HomeOverview from '@/components/HomeOverview.vue';
import ChartStatistics from '@/components/ChartStatistics.vue';

export default {
  name: 'HomeView',
  components: { ChartStatistics, HomeOverview, StatCard, ViewHeader },
  props: {},
  data() {
    return {
      subtitle: 'Jouw maandelijkse statistieken',
    };
  },
};
</script>

<template>
  <div>
    <view-header title="Statistieken" :sub-title="subtitle"/>
    <chart-statistics/>
  </div>
</template>

<style scoped>
</style>
